
var CRcarrierServiceEnabled = true;
document.addEventListener('crPickupProductAdded', function (e) {
  //console.log('-------------------------------Pickup added')
})

document.addEventListener('crPickupActivated', function (e) {
  var selectElement = document.querySelector('#storeUL');
  if (selectElement && selectElement.length > 1) {
      //selectElement.options[1].style.display = 'none'; // Hides the second option
      // or
      //selectElement.remove(1); // Removes the second option entirely
  }
  /*setTimeout(function(){
    console.log('**** *****')
	  jqCR("#8965").prop('disabled', true);
  }, 500)  */
  var pickupLabel = jqCR('#pickup-date-label').text()
  jqCR('#pickup-date-label').html(pickupLabel + '<span class="cr-red"> *required</span>')
  
  var pickupName = jqCR('#pickup-name-label').text()
  jqCR('#pickup-name-label').html(pickupName + '<span class="cr-red"> *required</span>')
  
  var pickupPhone = jqCR('#pickup-number-label').text()
  jqCR('#pickup-number-label').html(pickupPhone + '<span class="cr-red"> *required</span>')

  var pickupEmail = jqCR('#pickup-email-label').text()
  jqCR('#pickup-email-label').html(pickupEmail + '<span class="cr-red"> *required</span>')


  jqCR('#storeUL option').each(function(){
    var storeId = jQuery(this).data('store-id');
    if (!storeId) return;
    var zipCode = jQuery(this).data('zip-code');
    var city = jQuery(this).data('city');
    var storeName = jQuery(this).data('name');
    var storeAddress = jQuery(this).data('address');
    var storeCompany = jQuery(this).data('company');    

	var locationDescription = storeName + '- ' ;
    locationDescription += storeAddress;
    //locationDescription += zipCode + ' '  
    console.log(locationDescription)
    var content = jqCR(this).html(locationDescription);
  
  })
})

document.addEventListener('crStorePickupInit', function (e) {
  
})
var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  if (typeof selectedStore !== "undefined") {
  var selectedStoreId = selectedStore.storeID || 0;
  console.log(selectedStoreId);   
  
  // SE Portland Pickup
  if (selectedStoreId === 686) {
        picker.set('disable', [ 					       
                           { from: [2020, 8, 10], to: [2026, 3, 16] }, 
                           { from: [2026, 3, 19], to: [2045, 9, 7] }
                          ]);
        picker.set('max', 140);   
  } else 
  // St Johns Pickup
  if (selectedStoreId === 5704) {
    picker.set('disable', [
					                { from: [2020, 8, 10], to: [2026, 3, 23] }, 
                          { from: [2026, 3, 26], to: [2045, 9, 7] }
                          ]);
        picker.set('max', 140);   
  } else
  // Beaverton Pickup
  if (selectedStoreId === 4447) {
    picker.set('disable', [
					                { from: [2020, 8, 10], to: [2026, 3, 30] }, 
                          { from: [2026, 4, 3], to: [2045, 9, 7] }
                          ]);
        picker.set('max', 140);   
  } else 
    //East Portland Pickup
    if (selectedStoreId === 2028) {
    picker.set('disable', [
					                { from: [2020, 8, 10], to: [2026, 4, 7] }, 
                          { from: [2026, 4, 10], to: [2045, 9, 7] }
                          ]);
        picker.set('max', 140);   
  } 
    else {
      picker.set('disable', blackoutdatesCollection);
  }
    
}
  
}

var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);
  timepicker.set('disable',[{ from: [12, 30], to: [13, 00] }]); 
  if((selectedDate.getDate() === 19 && selectedMonth === 3)){
    //timepicker.set('disable',[{ from: [9, 00], to: [11, 0] }]); 
    //timepicker.set('disable',[{ from: [11, 0], to: [11, 15] }]); 
    //timepicker.set('disable',[9, 30]);   
    //timepicker.set('disable',[12, 0]); 
  }

  if((selectedDate.getDate() === 3 && selectedMonth === 4)){
    //timepicker.set('disable',[{ from: [8, 00], to: [11, 0] }]); 
    //timepicker.set('disable',[{ from: [12, 0], to: [13, 30] }]); 
    //timepicker.set('disable',[9, 30]);   
    //timepicker.set('disable',[9, 0]); 
  }
  
  if((selectedDate.getDate() === 4 && selectedMonth === 4)){
   //timepicker.set('disable',[{ from: [8, 00], to: [12, 0] }]);  
    //timepicker.set('disable',[10, 30]); 
  }
  
  if((selectedDate.getDate() === 26 && selectedMonth === 3)){
   /*timepicker.set('disable',[
     { from: [10, 00], to: [10, 0] },
     { from: [13, 30], to: [13, 30] }
   ]);  */
   
  }
  
  if((selectedDate.getDate() === 27 && selectedMonth === 3)){
   /*timepicker.set('disable',[
     { from: [8, 00], to: [9, 0] },
     { from: [10, 00], to: [10, 0] },
     { from: [12, 00], to: [12, 0] }
   ]);  */
   
  }

  
  // if(
  //   (selectedDate.getDate() === 2 && selectedMonth === 9)
  //   ||  (selectedDate.getDate() === 9 && selectedMonth === 9)
  //   ||  (selectedDate.getDate() === 16 && selectedMonth === 9)
  //   ||  (selectedDate.getDate() === 23 && selectedMonth === 9)
  // ) {
  // 	timepicker.set('max',[15, 0]); 
  // }
	
}